import { css, type Theme } from "@emotion/react";

import * as dimensions from "@styles/emotion-styles/dimensions";

export const wrapper = (theme: Theme) => css`
  @media (max-width: ${dimensions.phoneLargeMax}) {
    gap: ${theme.ds5.spacing.gap.large};
  }
`;

export const heading = css`
  text-align: center;
  max-width: 856px;
`;

export const headingTitle = css`
  text-align: center;
`;

export const subheading = css`
  max-width: 636px;
  text-align: center;
`;

export const marketingCard = (theme: Theme) => css`
  width: 614px;
  max-width: 100%;
  background-color: ${theme.ds5.surface.level0};
`;

export const marketingInner = (theme: Theme) => css`
  @media (max-width: ${dimensions.phoneLargeMax}) {
    flex-direction: column;
    align-items: stretch;
    gap: ${theme.ds5.spacing.gap.medium};
  }
`;

export const heroPicture = css`
  display: block;
  width: 164px;
  height: 106px;
  flex-shrink: 0;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    width: 100%;
    height: auto;
    aspect-ratio: 164 / 106;
  }
`;

export const heroImage = (theme: Theme) => css`
  display: block;
  width: 100%;
  height: 100%;
  border-radius: ${theme.ds5.radius.background.medium};
  object-fit: cover;
`;

export const marketingCopy = css`
  flex: 1;
  min-width: 0;
`;

export const inlineLink = css`
  display: inline;
`;
